﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {PlaceDetails} from "@2d-front-monorepo/design-library";
import {Address} from "../types/Address";

function getLongName(place: PlaceDetails, key: string): string {
	return place.addressComponents.find((component) => component.types.includes(key))?.longText || "";
}

export default function placeDetailsToAddress(place: PlaceDetails): Address {
	let streetNumber = getLongName(place, "street_number");
	const street = getLongName(place, "route");
	const city = getLongName(place, "locality");
	const state = getLongName(place, "administrative_area_level_1");
	const postalCode = getLongName(place, "postal_code");

	if (isNullOrEmpty(streetNumber)) {
		const extractedStreetNumber: number = Number(
			place.formattedAddress?.split(" ")[0]
		);

		if (!isNaN(extractedStreetNumber)) {
			streetNumber = extractedStreetNumber.toString();
		}
	}

	return {
		streetNumber,
		street,
		postalCode,
		state,
		city
	};
}
